import queries from '@apis/queries';
import UserApi from '@apis/user/UserApi';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@router/stackflow';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

import useUserDetail from './useUserDetail';

function useNickname() {
  const [nickname, setNickname] = useState<string>('');
  const toast = useToast();
  const userDetail = useUserDetail();
  const nicknameHelperText = nickname.length > 16
    ? '닉네임은 최대 16자까지 설정할 수 있습니다' : '';
  const { push } = useFlow();
  const queryClient = useQueryClient();
  const { mutate } = useMutation({
    mutationFn: UserApi.updateNickname,
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: queries.user._def });
      push('NickNameChangeModal', {});
    },
    onError(e) {
      console.error(e);
      toast.error('닉네임 변경중 오류가 발생하였습니다..');
    },
  });
  const handleUpdateNickname = async () => {
    if (nicknameHelperText.length > 20) {
      toast.error('닉네임은 최대 20자까지 설정할 수 있습니다.');
      return;
    }
    if (nickname.length === 0) {
      toast.error('닉네임을 입력해주세요.');
      return;
    }
    mutate(nickname);
  };

  useEffect(() => {
    if (userDetail) {
      setNickname(userDetail.nickname);
    }
  }, [userDetail]);
  return {
    nickname,
    setNickname,
    handleUpdateNickname,
    nicknameHelperText,
  };
}

export default useNickname;
